import React from 'react';

import { Background } from '../components/Background';
import { Banner } from '../components/Banner';
import { Footer } from '../components/Footer';
import { Navbar } from '../components/Navbar';
import { PageTemplate } from '../components/PageTemplate';

export const Terms = React.memo(() => (
  <div className="relative size-full">
    <Background />
    <Navbar />
    <div className="z-10 flex flex-col">
      <PageTemplate>
        <div className="flex h-[260px] flex-col items-center justify-start text-center">
          <button
            className="w-[121px] cursor-pointer rounded-full bg-[#FF9983] p-1 text-[13px] font-medium leading-[23px] 
          text-[#120A0B] transition-transform duration-300 ease-in-out hover:rotate-[-10deg] hover:scale-110 hover:shadow-xl"
            id="easter-egg"
          >
            Terms of Service
          </button>

          <h1 className="text-[63px] font-bold leading-[73px] text-[#120A0B]">Terms of Service</h1>
          <h2 className="mt-[30px] text-[17px] leading-[30px] text-[#454140]">
            By using Webcrumbs, you agree to these Terms of Service.
          </h2>
        </div>

        <div className="flex flex-col items-start justify-start">
          <div className="gap-[31px]">
            <h1 className="text-[33px] font-bold leading-[51px] text-[#120A0B]">Introduction</h1>
            <p className="mb-[29px] mt-[30px] text-[17px] text-[#666666]">
              Webcrumbs provides tools for creating, sharing, and embedding plugins and frontend components. By
              accessing or using Webcrumbs, you agree to these Terms.
            </p>
          </div>

          <div className="gap-[31px]">
            <h2 className="text-[22px] font-medium leading-[33px] text-[#000000]">User-Generated Content</h2>
            <p className="mb-[29px] mt-[30px] text-[17px] text-[#666666]">
              You own the content you create on Webcrumbs. By default, your components remain private, even on the free
              plan. If you submit content to the Templates section, you grant Webcrumbs a non-exclusive, royalty-free
              license to display and distribute it under an open-source license.
            </p>
          </div>

          <div className="gap-[31px]">
            <h2 className="text-[22px] font-medium leading-[33px] text-[#000000]">Privacy & Data Usage</h2>
            <p className="mb-[29px] mt-[30px] text-[17px] text-[#666666]">
              Webcrumbs does not use cookies. We store preferences locally using localStorage to enhance user privacy.
              However, third-party services such as Clarity and Google Analytics 4 (GA4) may use cookies independently,
              which users can manage in their browser settings.
            </p>
          </div>

          <div className="gap-[31px]">
            <h2 className="text-[22px] font-medium leading-[33px] text-[#000000]">Acceptable Use</h2>
            <p className="mb-[29px] mt-[30px] text-[17px] text-[#666666]">
              Users agree not to misuse Webcrumbs for illegal, abusive, or malicious purposes. Prohibited actions
              include uploading unauthorized copyrighted material, distributing malicious code, or interfering with
              platform operations.
            </p>
          </div>

          <div className="gap-[31px]">
            <h2 className="text-[22px] font-medium leading-[33px] text-[#000000]">Third-Party Services</h2>
            <p className="mb-[29px] mt-[30px] text-[17px] text-[#666666]">
              Webcrumbs integrates with Clarity and Google Analytics 4 (GA4) for analytics. These services may collect
              anonymized usage data and set cookies. Webcrumbs does not sell, trade, or rent personal information.
            </p>
          </div>

          <div className="gap-[31px]">
            <h2 className="text-[22px] font-medium leading-[33px] text-[#000000]">Limitation of Liability</h2>
            <p className="mb-[29px] mt-[30px] text-[17px] text-[#666666]">
              Webcrumbs is provided "as is" without warranties of any kind. We are not liable for any direct, indirect,
              or incidental damages resulting from platform use.
            </p>
          </div>

          <div className="gap-[31px]">
            <h2 className="text-[22px] font-medium leading-[33px] text-[#000000]">Changes to These Terms</h2>
            <p className="mb-[29px] mt-[30px] text-[17px] text-[#666666]">
              Webcrumbs may update these Terms at any time. Changes will be posted on this page with an updated revision
              date. Continued use of the platform constitutes acceptance of the revised Terms.
            </p>
          </div>
        </div>
      </PageTemplate>
      <Banner />
      <Footer />
    </div>
  </div>
));
